import "../../styles/pages/Adm/global.adm.styles.css"
import { ButtonCenter } from "../../components/adm/ButtonCenter"
import { LoaginScreen } from "../../components/adm/LoadingScreen"
import { useState } from "react"
import { fetchAddData } from "../../../lib/fetchAddData"
import { fetchUpdateWithID } from "../../../lib/fetchUpdateWithID"
import { fetchUploadFile } from "../../../lib/fetchUploadFile"

const initalStateFormData = {
    position: "1",
    name: "",
    link: "",
    shortDescrip: "",
    longDescrip: "",
    imgHome: "",
    imgPage: ""
}

export const AddService = () => {
    const [loadScreen, setLoadScreen] = useState(false)
    const [formData, setFormData] = useState(initalStateFormData)
    const [image, setImage] = useState(null)
    const [imagePage, setImagePage] = useState(null)

    function handleInputChange(e) {
        let { name, value } = e.target
        setFormData((prevClass) => ({ ...prevClass, [name]: value }))
    }

    function handleImagemSelecionada(e) {
        if (e.target.files && e.target.files[0]) {
            setImage(e.target.files[0])
        } else {
            setImage(null)
        }
    }

    function handleImagemPageSelecionada(e) {
        if (e.target.files && e.target.files[0]) {
            setImagePage(e.target.files[0])
        } else {
            setImagePage(null)
        }
    }

    function createLinkFunc() {
        let { name } = formData
        // Converte todas as letras maiúsculas para minúsculas
        let nameFormatted = name.toLowerCase()
        // Substitui espaços por hífens
        nameFormatted = nameFormatted.replace(/\s+/g, '-')
        setFormData((prevClass) => ({ ...prevClass, link: nameFormatted }))
    }

    function dataValidator() {
        if (formData.name && formData.shortDescrip && formData.longDescrip && formData.position && image && imagePage) {
            return true
        }
        return false
    }

    async function handleSubmit(e) {
        e.preventDefault()
        setLoadScreen(true)
        let validadeData = dataValidator()
        if (validadeData) {
            try {
                let docRef = await fetchAddData({
                    collectionName: "services", newData: formData
                })
                let updateID = fetchUpdateWithID(docRef)
                let uploadedImage
                if (image) {
                    uploadedImage = await fetchUploadFile({
                        docRef: docRef, image: image, tagImg: "imgHome"
                    })
                }
                if (imagePage) {
                    uploadedImage = await fetchUploadFile({
                        docRef: docRef, image: imagePage, tagImg: "imgPage"
                    })
                }
                if (docRef && updateID && uploadedImage) {
                    setLoadScreen(false)
                    alert("Cadastrado com Sucesso")
                    resetInputs()
                }
            } catch (error) {
                setLoadScreen(false)
                alert("Erro ao Cadastrar", error)
            }
        } else {
            setLoadScreen(false)
            alert("Confira os campos")
        }
    }

    function resetInputs() {
        setFormData(initalStateFormData)
        setImage(null)
        setImagePage(null)
    }

    return (
        <>
            <ButtonCenter
                homeBtn={true}
                goBackBtn={true}
            />
            <div className="div-adm-center">
                <form className="form-adm" onSubmit={handleSubmit}>
                    <p>Adicionar Serviço</p>
                    <div className="box-position">
                        <p>Posição:</p>
                        <input
                            type="number"
                            placeholder="Posição"
                            name="position"
                            onChange={handleInputChange}
                            value={formData.position}
                            min={0}
                        />
                    </div>
                    <input
                        type="text"
                        placeholder="Nome"
                        name="name"
                        onChange={handleInputChange}
                        onBlur={createLinkFunc}
                        value={formData.name}
                    />
                    <textarea
                        placeholder="Descrição curta para Home"
                        name="shortDescrip"
                        onChange={handleInputChange}
                        value={formData.shortDescrip}
                    />
                    <textarea
                        placeholder="Texto Longo para página"
                        name="longDescrip"
                        onChange={handleInputChange}
                        value={formData.longDescrip}
                    />
                    <label>
                        <p> {image ? "Imagem Home Anexada" : "Imagem Home não anexada"} </p>
                        <input type="file" onChange={handleImagemSelecionada} />
                    </label>
                    <label>
                        <p> {imagePage ? "Imagem Page Anexada" : "Imagem Page não anexada"} </p>
                        <input type="file" onChange={handleImagemPageSelecionada} />
                    </label>
                    <button type="submit"> Adicionar </button>
                </form>
            </div>
            {loadScreen && <LoaginScreen />}
        </>
    )
}